import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

let successTimeoutOuter = null;
let successTimeoutInner = null;

const Success = ({ setShowSuccess }) => {
	const dispatch = useDispatch();
	const success = useSelector(state => state.ui.showSuccess);

	const reset = clear => {
		clearTimeout(successTimeoutOuter);
		clearTimeout(successTimeoutInner);
		const toaster = document.getElementById('toaster');
		if (toaster) toaster.style.opacity = '1';
		clear && dispatch(setShowSuccess(false));
	};

	React.useEffect(() => {
		return () => {
			reset(true);
		};
	}, []);

	React.useEffect(() => {
		reset();
		if (success) {
			successTimeoutOuter = setTimeout(() => {
				const toaster = document.getElementById('toaster');
				if (toaster) toaster.style.opacity = '0';
				successTimeoutInner = setTimeout(() => {
					dispatch(setShowSuccess(false));
				}, 500);
			}, 2500);
		}
	}, [success]);

	if (!success) return null;

	return (
		<div onClick={() => reset(true)} id="toaster" className="toaster-success">
			<div className="flex flex-center">
				<i className="fa fa-circle-check mr10" />
				<span className="flex-grow">{success}</span>
				<i className="fa fa-times ml10" />
			</div>
		</div>
	);
};

export default Success;
